import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { createWooOrder } from './action.ts';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import './offers.scss';
const OrderSummaryScreen = ({ cartItems, onBackToCart, onPlaceOrder }) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  let userName = query.get('user_name') || '';
  let userPhone = query.get('user_phone') || '';
  //vendor supervisors case since they dont have userphone and username in url
  if (!userName || !userPhone) {
  const stored = localStorage.getItem("userdetails");
  if (stored) {
    const parsed = JSON.parse(stored);
    if (parsed && parsed.user) {
      userName = userName || parsed.user.name || '';
      userPhone = userPhone || parsed.user.phone || '';
    }
  }
}

  const [loading, setLoading] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState('');
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
const getDeliveryDate = () => {
  const today = new Date();
  let year = today.getFullYear();
  let month = today.getMonth() + 1; 
  if (month > 11) {
    month = 0;
    year += 1;
  }

  const deliveryDate = new Date(year, month, 5);
  const monthName = deliveryDate.toLocaleString("en-IN", { month: "long" });

  return `5th ${monthName}`;
};

  const total = cartItems.reduce((acc, item) => acc + item.price * (item.quantity || 1), 0);
  const handlePlaceOrder = () => {
    if (!userName.trim() || !userPhone.trim()) {
      alert('User name or phone not found in URL.');
      return;
    }

    const [firstName, ...lastNameParts] = userName.trim().split(' ');
    const lastName = lastNameParts.join(' ') || 'Customer';

    const formattedItems = cartItems.map(item => ({
      product_id: item.id,
      quantity: item.quantity || 1,
    }));

    const customerData = {
      first_name: firstName,
      last_name: lastName,
      phone: userPhone,
      email: 'default@email.com',
      address_1: 'Default Street',
      city: 'Bengaluru',
      state: 'KA',
      postcode: '560001',
      country: 'IN',
    };

    setLoading(true);

    createWooOrder(
      customerData.first_name,
      customerData.last_name,
      customerData.phone,
      formattedItems
    )
      .then((res) => {
        setLoading(false);
        if (res.success) {
          toast.success('Order placed successfully!');
          const d = getDeliveryDate();
          setDeliveryDate(d);
          setShowDeliveryModal(true);
        } else {
          console.error(res.error);
          alert('Failed to place order. Please try again.');
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        alert('Something went wrong.');
      });
  };

  return (
    <>
    <Box className="order-summary-container">
      <Box className="order-summary-icon-box">
        <ShoppingCartIcon sx={{ color: '#fff', fontSize: 60 }} />
      </Box>

      <Typography variant="h5" className="order-summary-heading">Order Summary</Typography>
      <Typography variant="body1" className="order-summary-description">
        Please review your order before proceeding to checkout.
      </Typography>

      <Box className="order-details-box">
        <Typography fontWeight={600} mb={1} fontSize={15}>Order Details:</Typography>
        {cartItems.length === 0 ? (
          <Typography color="error" fontSize={14}>No items in your cart.</Typography>
        ) : (
          cartItems.map(item => (
            <Box key={item.id} className="order-item">
              <img src={item.image} alt={item.name} className="order-item-image" />
              <Box flex={1}>
                <Typography fontSize={14} fontWeight={500}>{item.name}</Typography>
                <Typography fontSize={13} color="#666">
                  ₹{item.price} × {item.quantity || 1}
                  {item.originalPrice && item.originalPrice > item.price && (
                    <span className="price-original">₹{item.originalPrice}</span>
                  )}
                  {item.discountPercent && item.discountPercent > 0 && (
                    <span className="price-discount">({item.discountPercent}% off)</span>
                  )}
                </Typography>
              </Box>
            </Box>
          ))
        )}
        <Typography className="order-summary-total">Total: ₹{total}</Typography>
      </Box>

      <Box className="order-summary-actions">
        <Button
          variant="outlined"
          className="start-shopping-btn"
          onClick={handlePlaceOrder}
          disabled={loading}
        >
          {loading ? 'Placing Order...' : 'Place Order'}
        </Button>
        <Button
          variant="outlined"
          className="start-shopping-btn"
          onClick={onBackToCart}
        >
          Back to Cart
        </Button>
      </Box>
    </Box>
      <Dialog open={showDeliveryModal} onClose={() => setShowDeliveryModal(false)}>
        <DialogTitle>🎉 Order Placed!</DialogTitle>
        <DialogContent>
          <Typography>
            Your order will be delivered by <b>{deliveryDate}</b>.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
              variant="contained"
              onClick={() => {
                setShowDeliveryModal(false);
                onPlaceOrder();   
              }}
            >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      </>
  );
};

export default OrderSummaryScreen;

